import { render, staticRenderFns } from "./CreateHeadDialog.vue?vue&type=template&id=48ca9c73"
import script from "./CreateHeadDialog.vue?vue&type=script&lang=js"
export * from "./CreateHeadDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports